import { render, staticRenderFns } from "./AdvImageElement.vue?vue&type=template&id=36c48bbe&scoped=true&"
import script from "./AdvImageElement.vue?vue&type=script&lang=js&"
export * from "./AdvImageElement.vue?vue&type=script&lang=js&"
import style0 from "./AdvImageElement.vue?vue&type=style&index=0&id=36c48bbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c48bbe",
  null
  
)

export default component.exports